module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "myBill",
    attrs: {
      "id": "myBill"
    }
  }, [_c('div', {
    staticClass: "bullTop"
  }, [_c('section', {
    staticClass: "loan-lists"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "repo-notice-list__search",
    attrs: {
      "inline": true,
      "model": _vm.search,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核状态",
      "label-width": "70"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectapprove
    },
    model: {
      value: (_vm.approveListValue),
      callback: function($$v) {
        _vm.approveListValue = $$v
      },
      expression: "approveListValue"
    }
  }, _vm._l((_vm.approveList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "凭证号码",
      "label-width": "70"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.search.bizNo),
      callback: function($$v) {
        _vm.$set(_vm.search, "bizNo", $$v)
      },
      expression: "search.bizNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btnAdd",
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.billData()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticClass: "btnAdd",
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.bounced()
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "btnAdd",
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.importData()
      }
    }
  }, [_vm._v("批量导入(EXCEL)")]), _vm._v(" "), _c('el-button', {
    staticClass: "btnAdd",
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.importData('ocr')
      }
    }
  }, [_vm._v("批量导入(OCR)")])], 1)], 1), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "btnPost"
  })]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-import",
    attrs: {
      "title": "批量导入(EXCEL)",
      "visible": _vm.dialogImportVisibleExcel,
      "modal-append-to-body": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogImportVisibleExcel = $event
      }
    }
  }, [_c('div', {
    class: {
      'import-content': _vm.importFlag === 1, 'hide-dialog': _vm.importFlag !== 1
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.importUrl,
      "name": _vm.name,
      "limit": 1,
      "data": _vm.excelData,
      "headers": _vm.importHeaders,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.beforeUploadImportExcel,
      "on-error": _vm.uploadFailImport,
      "on-success": _vm.uploadSuccessImport,
      "file-list": _vm.fileList,
      "with-credentials": _vm.withCredentials
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.processing
    }
  }, [_vm._v(_vm._s(_vm.uploadTip))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "round": ""
    },
    on: {
      "click": _vm.downTemplate
    }
  }, [_vm._v("下载模板")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传excel文件")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-import",
    attrs: {
      "title": "增值税发票批量导入(OCR自动识别)",
      "visible": _vm.dialogImportVisibleOcr,
      "modal-append-to-body": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogImportVisibleOcr = $event
      }
    }
  }, [_c('div', {
    staticClass: "financing-dialog",
    class: {
      'import-content': _vm.importFlag === 1, 'hide-dialog': _vm.importFlag !== 1
    },
    staticStyle: {
      "height": "150px"
    }
  }, [_c('el-form', {
    ref: "ruleFormImport",
    staticClass: "demo-ruleForm financing-dialog-form-body",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rulesImport,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同编号",
      "prop": "contractNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入合同名称及合同编号"
    },
    model: {
      value: (_vm.ruleForm.contractNumber),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "contractNumber", $$v)
      },
      expression: "ruleForm.contractNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品名称",
      "prop": "baseProductId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择产品"
    },
    model: {
      value: (_vm.ruleForm.baseProductId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "baseProductId", $$v)
      },
      expression: "ruleForm.baseProductId"
    }
  }, _vm._l((_vm.productList), function(item) {
    return _c('el-option', {
      key: item.productId,
      attrs: {
        "label": item.productName,
        "value": item.productId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "签署日期",
      "prop": "signDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "签署日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": function($event) {
        return _vm.dateChange($event, 'signDate')
      }
    },
    model: {
      value: (_vm.ruleForm.signDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "signDate", $$v)
      },
      expression: "ruleForm.signDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item2"
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.importUrl,
      "headers": _vm.importHeaders,
      "limit": 1,
      "data": _vm.ocrData,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.beforeUploadImportOcr,
      "on-error": _vm.uploadFailImport,
      "on-success": _vm.uploadSuccessImportOcr,
      "file-list": _vm.fileList,
      "with-credentials": _vm.withCredentials
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.processing
    }
  }, [_vm._v(_vm._s(_vm.uploadTip))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("请上传zip压缩文件（"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("请将png\\jpg\\jpeg格式的发票图片打包上传")]), _vm._v("）")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog__footer",
    staticStyle: {
      "margin-top": "3.5rem"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.importOcr
    }
  }, [_vm._v("开始导入")])], 1)])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.voucherInfoList,
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "70",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "show-overflow-tooltip": "",
      "prop": "type",
      "label": "类型",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "show-overflow-tooltip": "",
      "prop": "buyerName",
      "label": "买方",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "show-overflow-tooltip": "",
      "prop": "bizNo",
      "label": "凭证号码",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "show-overflow-tooltip": "",
      "label": "凭证金额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#EB662B"
          }
        }, [_vm._v("¥" + _vm._s(_vm._f("addThousandSign")(scope.row.receivableAmount, 2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "show-overflow-tooltip": "",
      "prop": "authStateName",
      "label": "审核状态",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "show-overflow-tooltip": "",
      "prop": "state",
      "width": "100",
      "label": "凭证状态",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          class: ['btn', 'operation', (scope.row.canEdit) ? '' : 'btn-disable'],
          attrs: {
            "size": "mini",
            "type": scope.row.canEdit ? 'primary' : '',
            "disabled": (!scope.row.canEdit)
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          staticClass: "btn operation",
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.rowClick(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          class: ['btn', 'operation', scope.row.canDelete ? '' : 'btn-disable'],
          attrs: {
            "size": "mini",
            "type": (scope.row.canDelete) ? 'danger' : '',
            "disabled": (!scope.row.canDelete)
          },
          on: {
            "click": function($event) {
              return _vm.removeData(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.voucherInfoList.length > 0) ? _c('el-pagination', {
    staticClass: "step3_pagination",
    attrs: {
      "page-size": _vm.pageSize,
      "total": _vm.voucherInfoCount,
      "current-page": _vm.pageCurrent,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.changePage
    }
  }) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "financing-dialog",
    attrs: {
      "visible": _vm.DialogInputBankInfo,
      "close-on-click-modal": false,
      "top": "5%"
    },
    on: {
      "update:visible": function($event) {
        _vm.DialogInputBankInfo = $event
      }
    }
  }, [_c('div', {
    staticClass: "financing-dialog-form"
  }, [_c('el-form', {
    ref: "ruleForm9",
    staticClass: "demo-ruleForm financing-dialog-form-body",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules9,
      "label-width": "125px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "融资产品名称",
      "prop": "baseProductId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择融资产品"
    },
    model: {
      value: (_vm.ruleForm.baseProductId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "baseProductId", $$v)
      },
      expression: "ruleForm.baseProductId"
    }
  }, _vm._l((_vm.productList), function(item) {
    return _c('el-option', {
      key: item.productId,
      attrs: {
        "label": item.productName,
        "value": item.productId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "贸易合同买方",
      "prop": "buyerId"
    }
  }, [_c('el-select', {
    staticClass: "buyerName",
    attrs: {
      "placeholder": "请选择贸易合同买方"
    },
    model: {
      value: (_vm.ruleForm.buyerId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "buyerId", $$v)
      },
      expression: "ruleForm.buyerId"
    }
  }, _vm._l((_vm.ruleForm.buyerNameList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.buyerName,
        "value": item.buyerId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "label": '贸易合同\n名称及编号',
      "prop": "contractNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入贸易合同名称及编号"
    },
    model: {
      value: (_vm.ruleForm.contractNumber),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "contractNumber", $$v)
      },
      expression: "ruleForm.contractNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm financing-dialog-form-body",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "125px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "凭证类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择凭证类型",
      "disabled": _vm.voucherInfoId > 0,
      "onchange": _vm.changeFrom()
    },
    model: {
      value: (_vm.ruleForm.type),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "type", $$v)
      },
      expression: "ruleForm.type"
    }
  }, _vm._l((_vm.typeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm financing-dialog-form-body",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules2,
      "label-width": "125px"
    }
  }, [(!_vm.dome) ? [_c('el-form-item', {
    attrs: {
      "label": "凭证日期",
      "prop": "startTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "凭证日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": function($event) {
        return _vm.dateChange($event, 'startTime')
      }
    },
    model: {
      value: (_vm.ruleForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "startTime", $$v)
      },
      expression: "ruleForm.startTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "凭证号码",
      "prop": "lnvoiceNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入凭证号码"
    },
    model: {
      value: (_vm.ruleForm.lnvoiceNumber),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "lnvoiceNumber", $$v)
      },
      expression: "ruleForm.lnvoiceNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "凭证金额",
      "prop": "contractAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入凭证金额"
    },
    model: {
      value: (_vm.ruleForm.contractAmount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "contractAmount", $$v)
      },
      expression: "ruleForm.contractAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入订单号"
    },
    model: {
      value: (_vm.ruleForm.ddh),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "ddh", $$v)
      },
      expression: "ruleForm.ddh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "送货单号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入送货单号"
    },
    model: {
      value: (_vm.ruleForm.receiptNo),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "receiptNo", $$v)
      },
      expression: "ruleForm.receiptNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品名"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入品名"
    },
    model: {
      value: (_vm.ruleForm.goodsName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "goodsName", $$v)
      },
      expression: "ruleForm.goodsName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "规格型号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入规格型号"
    },
    model: {
      value: (_vm.ruleForm.spec),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "spec", $$v)
      },
      expression: "ruleForm.spec"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数量"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入数量"
    },
    model: {
      value: (_vm.ruleForm.num),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "num", $$v)
      },
      expression: "ruleForm.num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "计量单位"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入计量单位"
    },
    model: {
      value: (_vm.ruleForm.unit),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "unit", $$v)
      },
      expression: "ruleForm.unit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单价"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入单价"
    },
    model: {
      value: (_vm.ruleForm.unitPrice),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "unitPrice", $$v)
      },
      expression: "ruleForm.unitPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "总价",
      "prop": "totalPrice"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入总价"
    },
    model: {
      value: (_vm.ruleForm.totalPrice),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "totalPrice", $$v)
      },
      expression: "ruleForm.totalPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应收账款净额",
      "prop": "netAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "应收账款净额"
    },
    model: {
      value: (_vm.ruleForm.netAmount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "netAmount", $$v)
      },
      expression: "ruleForm.netAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "签署日期",
      "prop": "signDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "签署日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": function($event) {
        return _vm.dateChange($event, 'signDate')
      }
    },
    model: {
      value: (_vm.ruleForm.signDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "signDate", $$v)
      },
      expression: "ruleForm.signDate"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('el-form', {
    ref: "ruleForm3",
    staticClass: "demo-ruleForm financing-dialog-form-body",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules3,
      "label-width": "125px"
    }
  }, [(_vm.dome1) ? [_c('el-form-item', {
    attrs: {
      "label": "订单日期",
      "prop": "djTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "订单日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": function($event) {
        return _vm.dateChange($event, 'djTime')
      }
    },
    model: {
      value: (_vm.ruleForm.djTime),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "djTime", $$v)
      },
      expression: "ruleForm.djTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单号",
      "prop": "deliveryNo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入订单号"
    },
    model: {
      value: (_vm.ruleForm.deliveryNo),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "deliveryNo", $$v)
      },
      expression: "ruleForm.deliveryNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单总值",
      "prop": "ddnum"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入订单总值"
    },
    model: {
      value: (_vm.ruleForm.ddnum),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "ddnum", $$v)
      },
      expression: "ruleForm.ddnum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品名",
      "prop": "pm"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入品名"
    },
    model: {
      value: (_vm.ruleForm.pm),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "pm", $$v)
      },
      expression: "ruleForm.pm"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "规格型号",
      "prop": "ggxh"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入规格型号"
    },
    model: {
      value: (_vm.ruleForm.ggxh),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "ggxh", $$v)
      },
      expression: "ruleForm.ggxh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单价",
      "prop": "dj"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入单价"
    },
    model: {
      value: (_vm.ruleForm.dj),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "dj", $$v)
      },
      expression: "ruleForm.dj"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "计量单位",
      "prop": "dw"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入计量单位"
    },
    model: {
      value: (_vm.ruleForm.dw),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "dw", $$v)
      },
      expression: "ruleForm.dw"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数量",
      "prop": "sl"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入数量"
    },
    model: {
      value: (_vm.ruleForm.sl),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sl", $$v)
      },
      expression: "ruleForm.sl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "货物总值",
      "prop": "zj"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入货物总值"
    },
    model: {
      value: (_vm.ruleForm.zj),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "zj", $$v)
      },
      expression: "ruleForm.zj"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应收账款净额",
      "prop": "netAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "应收账款净额"
    },
    model: {
      value: (_vm.ruleForm.netAmount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "netAmount", $$v)
      },
      expression: "ruleForm.netAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('el-form', {
    ref: "ruleForm4",
    staticClass: "demo-ruleForm financing-dialog-form-body",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules4,
      "label-width": "125px"
    }
  }, [(_vm.dome2) ? [_c('el-form-item', {
    attrs: {
      "label": "单据日期",
      "prop": "djTime2"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "单据日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": function($event) {
        return _vm.dateChange($event, 'djTime2')
      }
    },
    model: {
      value: (_vm.ruleForm.djTime2),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "djTime2", $$v)
      },
      expression: "ruleForm.djTime2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单据号码",
      "prop": "shrk"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入单据号码"
    },
    model: {
      value: (_vm.ruleForm.shrk),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "shrk", $$v)
      },
      expression: "ruleForm.shrk"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单据总值",
      "prop": "shnum"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入单据总值"
    },
    model: {
      value: (_vm.ruleForm.shnum),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "shnum", $$v)
      },
      expression: "ruleForm.shnum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应收账款净额",
      "prop": "netAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "应收账款净额"
    },
    model: {
      value: (_vm.ruleForm.netAmount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "netAmount", $$v)
      },
      expression: "ruleForm.netAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('el-form', {
    ref: "ruleForm5",
    staticClass: "demo-ruleForm financing-dialog-form-body",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules5,
      "label-width": "125px"
    }
  }, [(_vm.dome3) ? [_c('el-form-item', {
    attrs: {
      "label": "单据日期",
      "prop": "djTime3"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "单据日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": function($event) {
        return _vm.dateChange($event, 'djTime3')
      }
    },
    model: {
      value: (_vm.ruleForm.djTime3),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "djTime3", $$v)
      },
      expression: "ruleForm.djTime3"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单据号码",
      "prop": "jsnum"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入单据号码"
    },
    model: {
      value: (_vm.ruleForm.jsnum),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "jsnum", $$v)
      },
      expression: "ruleForm.jsnum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算单总金额",
      "prop": "jsdnum"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入结算单总金额"
    },
    model: {
      value: (_vm.ruleForm.jsdnum),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "jsdnum", $$v)
      },
      expression: "ruleForm.jsdnum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应收账款净额",
      "prop": "netAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "应收账款净额"
    },
    model: {
      value: (_vm.ruleForm.netAmount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "netAmount", $$v)
      },
      expression: "ruleForm.netAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('el-form', {
    ref: "ruleForm6",
    staticClass: "demo-ruleForm financing-dialog-form-body",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules6,
      "label-width": "125px"
    }
  }, [(_vm.dome5) ? [_c('el-form-item', {
    attrs: {
      "label": "票据号码",
      "prop": "pjnum"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入票据号码"
    },
    model: {
      value: (_vm.ruleForm.pjnum),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "pjnum", $$v)
      },
      expression: "ruleForm.pjnum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出票日期",
      "prop": "cpTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "出票日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": function($event) {
        return _vm.dateChange($event, 'cpTime')
      }
    },
    model: {
      value: (_vm.ruleForm.cpTime),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cpTime", $$v)
      },
      expression: "ruleForm.cpTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "汇票到期日",
      "prop": "receivableEndTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "汇票到期日",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": function($event) {
        return _vm.dateChange($event, 'receivableEndTime')
      }
    },
    model: {
      value: (_vm.ruleForm.receivableEndTime),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "receivableEndTime", $$v)
      },
      expression: "ruleForm.receivableEndTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出票人全称",
      "prop": "cprqc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入出票人全称"
    },
    model: {
      value: (_vm.ruleForm.cprqc),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cprqc", $$v)
      },
      expression: "ruleForm.cprqc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "承兑人全称",
      "prop": "cdrname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入承兑人全称"
    },
    model: {
      value: (_vm.ruleForm.cdrname),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cdrname", $$v)
      },
      expression: "ruleForm.cdrname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "label": '承兑人开户行\n行号',
      "prop": "acceptorBankSwift"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入承兑人开户行行号"
    },
    model: {
      value: (_vm.ruleForm.acceptorBankSwift),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "acceptorBankSwift", $$v)
      },
      expression: "ruleForm.acceptorBankSwift"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "label": '承兑人开户行\n名称',
      "prop": "cdrkname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入承兑人开户行名称"
    },
    model: {
      value: (_vm.ruleForm.cdrkname),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cdrkname", $$v)
      },
      expression: "ruleForm.cdrkname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "票据金额",
      "prop": "pmnum"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入票据金额"
    },
    model: {
      value: (_vm.ruleForm.pmnum),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "pmnum", $$v)
      },
      expression: "ruleForm.pmnum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应收账款净额",
      "prop": "netAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "应收账款净额"
    },
    model: {
      value: (_vm.ruleForm.netAmount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "netAmount", $$v)
      },
      expression: "ruleForm.netAmount"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('el-form', {
    ref: "ruleForm7",
    staticClass: "demo-ruleForm financing-dialog-form-body",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules7,
      "label-width": "125px"
    }
  }, [(_vm.dome6) ? [_c('el-form-item', {
    attrs: {
      "label": "票据号码",
      "prop": "pjnum2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入票据号码"
    },
    model: {
      value: (_vm.ruleForm.pjnum2),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "pjnum2", $$v)
      },
      expression: "ruleForm.pjnum2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出票日期",
      "prop": "cpTime2"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "出票日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": function($event) {
        return _vm.dateChange($event, 'cpTime2')
      }
    },
    model: {
      value: (_vm.ruleForm.cpTime2),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cpTime2", $$v)
      },
      expression: "ruleForm.cpTime2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "汇票到期日",
      "prop": "receivableEndTime2"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "汇票到期日",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": function($event) {
        return _vm.dateChange($event, 'receivableEndTime2')
      }
    },
    model: {
      value: (_vm.ruleForm.receivableEndTime2),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "receivableEndTime2", $$v)
      },
      expression: "ruleForm.receivableEndTime2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出票人全称",
      "prop": "cprqc2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入出票人全称"
    },
    model: {
      value: (_vm.ruleForm.cprqc2),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cprqc2", $$v)
      },
      expression: "ruleForm.cprqc2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "承兑人全称",
      "prop": "cdrname2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入承兑人全称"
    },
    model: {
      value: (_vm.ruleForm.cdrname2),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cdrname2", $$v)
      },
      expression: "ruleForm.cdrname2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "label": '承兑人开户行\n行号',
      "prop": "acceptorBankSwift2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入承兑人开户行行号"
    },
    model: {
      value: (_vm.ruleForm.acceptorBankSwift2),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "acceptorBankSwift2", $$v)
      },
      expression: "ruleForm.acceptorBankSwift2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "label": '承兑人开户行\n名称',
      "prop": "cdrkname2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入承兑人开户行"
    },
    model: {
      value: (_vm.ruleForm.cdrkname2),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cdrkname2", $$v)
      },
      expression: "ruleForm.cdrkname2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "票据金额",
      "prop": "pmnum2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入票据金额"
    },
    model: {
      value: (_vm.ruleForm.pmnum2),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "pmnum2", $$v)
      },
      expression: "ruleForm.pmnum2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应收账款净额",
      "prop": "netAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "应收账款净额"
    },
    model: {
      value: (_vm.ruleForm.netAmount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "netAmount", $$v)
      },
      expression: "ruleForm.netAmount"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('el-form', {
    ref: "ruleForm8",
    staticClass: "demo-ruleForm financing-dialog-form-body",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules8,
      "label-width": "125px"
    }
  }, [(_vm.dome7) ? [_c('el-form-item', {
    attrs: {
      "label": "应收账款净额",
      "prop": "netAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "应收账款净额"
    },
    model: {
      value: (_vm.ruleForm.netAmount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "netAmount", $$v)
      },
      expression: "ruleForm.netAmount"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "2rem",
      "margin-left": "2.5rem"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "smaller"
    }
  }, [_vm._v(" 温馨提示："), _c('br'), _vm._v("请将上述凭证的原件扫描图片或原件照片点击下方“+”号上传")])]), _vm._v(" "), _c('ul', {
    staticClass: "file-list__item-list"
  }, [_vm._l((_vm.sysFileIds), function(file) {
    return [(/\.pdf|\.doc|\.rar|\.zip|\.7z/g.test(file.fileName)) ? _c('li', {
      class: ['file-list__item-preview', ("file-list__\n                    " + (file.fileName.substr(file.fileName.lastIndexOf('.')+1)) + "-preview")],
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          return _vm.showPreviewImage(file.fileId, false)
        }
      }
    }, [_c('div', {
      staticClass: "file-list__item-delete",
      on: {
        "click": function($event) {
          return _vm.deleteUploadedFile(file.fileId)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-close"
    })]), _vm._v(" "), _c('div', {
      staticClass: "file-list__file-name"
    }, [_vm._v(_vm._s(file.fileName))])]) : _c('li', {
      staticClass: "file-list__item-preview"
    }, [_c('img', {
      attrs: {
        "src": (_vm.ajaxBaseUrl + "/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=" + (file.fileId) + "&tokenId=" + _vm.tokenId)
      },
      on: {
        "click": function($event) {
          return _vm.showPreviewImage(file.fileId, true)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "file-list__item-delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteUploadedFile(file)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-close"
    })])])]
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sysFileIds.length < 5),
      expression: " sysFileIds.length < 5"
    }],
    staticClass: "file-list__select-file picker"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer pinker",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "submit",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("提交")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "file-preview-modal",
    attrs: {
      "title": "图片预览",
      "visible": _vm.filePreview.show,
      "before-close": _vm.hidePreviewImage,
      "close-on-click-modal": false
    }
  }, [_c('div', {
    staticClass: "file-preview-modal__body"
  }, [_c('img', {
    attrs: {
      "src": _vm.filePreview.src,
      "alt": "图片预览"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog__footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "dialog__footer__confirm-btn",
    on: {
      "click": _vm.hidePreviewImage
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "progressDialog",
    attrs: {
      "title": " ",
      "visible": _vm.isShowProgress,
      "size": "tiny",
      "top": "20%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowProgress = $event
      }
    }
  }, [_c('el-progress', {
    staticClass: "upload_progress",
    attrs: {
      "text-inside": true,
      "stroke-width": 18,
      "percentage": _vm.progress
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f46beec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/MyBill.vue
// module id = 1083
// module chunks = 1